import { render } from "./AddReview.vue?vue&type=template&id=5c160d39&scoped=true"
import script from "./AddReview.vue?vue&type=script&lang=js"
export * from "./AddReview.vue?vue&type=script&lang=js"

import "./AddReview.vue?vue&type=style&index=0&id=5c160d39&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c160d39"]])

export default __exports__